// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"868":"5920fa6b","973":"1c307b15"}[chunkId] + ".chunk.css";
};